import React from 'react';

import Reveal from '../ui/Reveal';
import './why.scss';

const REASONS = [
  {
    num: '01',
    title: 'Direct access to senior engineers',
    text: 'No account managers relaying requests — you work straight with the people building your project.',
  },
  {
    num: '02',
    title: 'Senior talent, small-business price',
    text: 'The same caliber of data, dev and AI talent large enterprises hire — accessible to a small or mid-size business.',
  },
  {
    num: '03',
    title: 'Fixed scope, no scope creep',
    text: 'You know the deliverables, the timeline and the price before we start a single sprint.',
  },
  {
    num: '04',
    title: 'Built around your business day',
    text: 'Overlapping hours and async-first habits, so nothing waits on a slow reply.',
  },
];

export default function WhySection() {
  return (
    <section className="section section--dark why-section" id="why">
      <div className="wrap">
        <Reveal className="section-head">
          <p className="eyebrow">Why BizVision</p>
          <h2>Boutique attention. Enterprise rigor.</h2>
        </Reveal>

        <div className="why-grid">
          {REASONS.map((reason, index) => (
            <Reveal key={reason.num} delay={index * 80} className="why-item">
              <span className="why-item__num">— {reason.num}</span>
              <h3>{reason.title}</h3>
              <p>{reason.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
